module.exports = __webpack_public_path__ + "static/media/logo_fb.dc82126b.png";